// extracted by mini-css-extract-plugin
export default {"details__topBarContainer":"PackageAccessView_details__topBarContainer__APLVE"};